import { carleadCreationGetInitialProps } from '@wkda/carlead-creation-components';
import {
  BaseLeadPage,
  CarleadHIWWhyChooseWkdaFaq,
  CarleadStepCompoundCustomerPopupCustomerCounterBuyCar,
} from '@wkda/marketing-components';

function CarleadCreation() {
  return (
    <BaseLeadPage
      form={CarleadStepCompoundCustomerPopupCustomerCounterBuyCar}
      content={CarleadHIWWhyChooseWkdaFaq}
      showTerms={true}
    />
  );
}

CarleadCreation.getInitialProps = carleadCreationGetInitialProps;

export default CarleadCreation;
